/**
 * ScheduleSection - Schedule display for Americano
 */
import React, { useState } from 'react';
import { useTournament } from '../../contexts/TournamentContext';

const ScheduleSection = () => {
  const { state, getPlayerName } = useTournament();
  const { schedule, config } = state;
  const [openRounds, setOpenRounds] = useState({ 0: true });

  const getCourtName = (courtIndex) => {
    return config?.courtNames?.[courtIndex] || `Terrain ${courtIndex + 1}`;
  };

  const toggleRound = (index) => {
    setOpenRounds(prev => ({ ...prev, [index]: !prev[index] }));
  };

  if (!schedule?.rounds?.length) {
    return (
      <div className="section-inner">
        <div className="section-header">
          <h1><i className="bi bi-calendar3 me-3"></i>Planning</h1>
        </div>
        <div className="section-body">
          <div className="alert alert-warning">Aucun planning généré.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="section-inner">
      <div className="section-header">
        <h1><i className="bi bi-calendar3 me-3"></i>Planning</h1>
        <p className="lead">{schedule.rounds.length} tours · {schedule.rounds[0]?.matches?.length || 0} terrain{(schedule.rounds[0]?.matches?.length || 0) > 1 ? 's' : ''} / tour</p>
      </div>

      <div className="section-body">
        {schedule.rounds.map((round, roundIndex) => (
          <div key={roundIndex} className="round-card mb-3">
            <div
              className={`round-header ${openRounds[roundIndex] ? 'open' : ''}`}
              onClick={() => toggleRound(roundIndex)}
            >
              <h5>
                <i className="bi bi-play-circle me-2"></i>
                Tour {roundIndex + 1}
                <span className="match-count">({round.matches?.length || 0} matchs)</span>
              </h5>
              <i className={`bi bi-chevron-${openRounds[roundIndex] ? 'up' : 'down'}`}></i>
            </div>

            {openRounds[roundIndex] && (
              <div className="matches-list">
                {round.matches?.map((match, matchIndex) => (
                  <div key={matchIndex} className="match-line">
                    <strong>{getCourtName(match.courtIndex)}</strong> :{' '}
                    {match.team1.map(id => getPlayerName(id)).join(' & ')}{' '}
                    <span className="vs">vs</span>{' '}
                    {match.team2.map(id => getPlayerName(id)).join(' & ')}
                  </div>
                ))}
                {round.restingPlayers && round.restingPlayers.length > 0 && (
                  <div className="match-line text-muted">
                    <i className="bi bi-pause-circle me-1"></i>
                    Repos : {round.restingPlayers.map(id => getPlayerName(id)).join(', ')}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduleSection;
